import React from 'react';
import { useQuery, gql } from '@apollo/client';
import { IntlProvider, useIntl } from 'react-intl';
import MyHiringPosts from '../../components/StudentPlatform/pages/MyHiringPosts';
import ApolloWrapper from './ApolloWrapper';
import getMessages from '../../lib/i18n/getMessages';
import { CurrencyProvider } from '../../hooks/useCurrency';

const GET_MY_HIRING_POSTS = gql`
  query GetMyHiringPosts {
    myHiringPosts {
      id
      title
      position_type
      location
      remote
      description
      status
      views_count
      conversations_count
      saved_count
      published_at
      closed_at
      created_at
      updated_at
      user {
        id
        name
        allowed_name
      }
    }
  }
`;

const MyHiringPostsInner = () => {
  const intl = useIntl();
  const { loading, error, data } = useQuery(GET_MY_HIRING_POSTS);

  if (loading) {
    return (
      <div className="min-h-screen bg-neutral-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-neutral-600">{intl.formatMessage({ id: 'hiring.container.posts.loading' })}</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-neutral-50 flex items-center justify-center">
        <div className="text-center">
          <div className="text-red-600 text-5xl mb-4">⚠️</div>
          <h2 className="text-xl font-semibold text-neutral-900 mb-2">{intl.formatMessage({ id: 'hiring.container.posts.error_heading' })}</h2>
          <p className="text-neutral-600 mb-4">{error.message}</p>
          <a
            href="/dashboard"
            className="inline-flex items-center gap-2 text-blue-600 hover:text-blue-700 font-medium"
          >
            {intl.formatMessage({ id: 'hiring.container.posts.back_link' })}
          </a>
        </div>
      </div>
    );
  }

  // Transform snake_case GraphQL data to camelCase for the component
  const transformedPosts = (data.myHiringPosts || []).map(post => ({
    id: post.id,
    title: post.title,
    positionType: post.position_type,
    location: post.location,
    remote: post.remote,
    description: post.description,
    status: post.status,
    viewsCount: post.views_count,
    conversationsCount: post.conversations_count,
    savedCount: post.saved_count,
    publishedAt: post.published_at,
    closedAt: post.closed_at,
    createdAt: post.created_at,
    updatedAt: post.updated_at,
  }));

  return <MyHiringPosts posts={transformedPosts} />;
};

const MyHiringPostsContainer = (props, railsContext) => {
  window.locale = (railsContext && railsContext.i18nLocale) || window.locale || 'en';
  window.currency = (railsContext && railsContext.currency) || window.currency || 'USD';
  const locale = window.locale;
  return (
    <CurrencyProvider currency={(railsContext && railsContext.currency) || window.currency || 'USD'}>
      <IntlProvider locale={locale} messages={getMessages(locale)}>
        <ApolloWrapper>
          <MyHiringPostsInner />
        </ApolloWrapper>
      </IntlProvider>
    </CurrencyProvider>
  );
};

export default MyHiringPostsContainer;
